import dic from '@/assets/dictionary/index.js'
import { LANG } from '@/libs/constants'

const { forms } = dic[LANG]

export const newTabs = (forms) => {
  return [
    {
      type: 'l',
      label: forms.transporter,
      form: 'transporters',
    },
    {
      type: 'r',
      label: forms.shipper,
      form: 'shippers',
    },
  ]
}

export default {
  namespaced: true,
  state: {
    activeForm: 'transporters',
    tabs: newTabs(forms),
  },
  mutations: {
    SET_ACTIVE_FORM(state, payload) {
      state.activeForm = payload.form
    },
  },
}
